import Flow from 'nflow'
import utilsLib from './components/utils/utils.js'
import serviceProviderLib from './components/service-provider/service-provider.js'
import identityProviderLib from './components/identity-provider/identity-provider.js'
import requestManager from './components/request-manager/request-manager.js'

const utils = utilsLib
const serviceProvider = serviceProviderLib
const identityProvider = identityProviderLib


export {
  utils ,
  serviceProvider,
  identityProvider
}

export default parent => {
	const auth = Flow.create('fusion-authentication')
    .parent(parent)
    .data({
        validateSessionUrl: "",
        logoutUrl : "",
        relayState: '/app/',
        userDetails: {}
    })
    .on('user-details-request', sendUserDetails)
    .on('ensure-auth', ensureAuth)
    .on('set-channel', setChannel)
    .on('logout', logout)
  requestManager.init(auth);
  return auth
}

function setChannel(channel){
  const flow = this.target;
  flow.data().validateSessionUrl =  `/api/sp/v1/saml2/${channel}/validateSession`;
  flow.data().logoutUrl = `/api/sp/v1/saml2/${channel}/userLogout`;
}

function ensureAuth() {
  requestManager.ensureAuthenticated(this);
}

function logout(){
  requestManager.logout(this);
}

function sendUserDetails() {
  requestManager.sendUserDetails(this);
}




/** WEBPACK FOOTER **
 ** ./main.js
 **/